import React, { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import Modal from '@medflex/components/stories/Modal';
import Button from '@medflex/components/stories/Button';
import { showSuccessToast, showAlertToast } from '@medflex/components/stories/Toast';
import { useDispatch } from 'react-redux';
import { trackEvent } from '@medflex/utils/Tracking';
import Logger from '@medflex/utils/Logger';
import useLocationSearchParams from '../../hooks/useLocationSearchParams';
import useChatContacts from '../hooks/useChatContacts';
import useModal from '../hooks/useModal';

const PhysicianResendInvitationModule = () => {
  const { close } = useModal();
  const { t } = useTranslation('physician');
  const { contactId } = useLocationSearchParams();
  const { contacts } = useChatContacts();
  const dispatch = useDispatch();

  const closeModal = () => close({ modal: 'resend_invitation', contactId });

  useEffect(() => {
    if (!contactId) {
      closeModal();
    }
  }, []);

  const name = useMemo(() => {
    const contact = contacts.find(c => c.id === contactId);
    if (contact) {
      return contact.user.fullNameWithTitle;
    }
    return '';
  }, [contactId, contacts]);

  const handleResend = async event => {
    event.preventDefault();
    if (contactId) {
      try {
        await dispatch.patientInvitations.resend({ contactId });
        showSuccessToast(t('modals.resend_invitation.success'), null, {
          toastId: 'resendInvitationSuccess',
        });
        closeModal();
      } catch (e) {
        Logger.error(e);
        trackEvent(event, { actionText: 'failed' });
        showAlertToast(
          t('modals.resend_invitation.failure'),
          t('modals.resend_invitation.failure_text'),
          { toastId: 'resendInvitationFailed' },
        );
      }
    }
  };

  return (
    <Modal
      showCloseButton
      onClickCloseButton={closeModal}
      title={t('modals.resend_invitation.title')}
    >
      <div data-component="PhysicianResendInvitationModule">
        <form onSubmit={handleResend}>
          <div className="flex flex-col mt-12 lg:mt-0">
            <p>{t('modals.resend_invitation.text', { allowHtml: true, name })}</p>
          </div>
          <p className="flex justify-center w-full mt-16 lg:mt-8 mb-4">
            <Button type="submit">{t('modals.resend_invitation.button')}</Button>
          </p>
        </form>
      </div>
    </Modal>
  );
};

export default PhysicianResendInvitationModule;
